import PropTypes from 'prop-types'
import React from 'react'

import {
  Root,
  Track,
  Item,
  TextItem,
  FixedTextItem,
  LegacyItem,
  LegacyContent,
  LegacyImg,
  TestBoxesIcon,
  MacbookIcon,
  BundleTestsIcon,
  GiftIcon,
  StartMoleculeIcon,
} from './styles'

const CDN_BANNER = 'https://cdn3.atlas.ru/website/shared/banner'

const isNewSchema = items =>
  Array.isArray(items) && items.some(i => i && i.type)

const renderNewItem = (item, i) => {
  if (item.type === 'testBoxes') {
    return <TestBoxesIcon key={i} />
  }
  if (item.type === 'macbook') {
    return <MacbookIcon key={i} />
  }
  if (item.type === 'bundleTests') {
    return <BundleTestsIcon key={i} />
  }
  if (item.type === 'gift') {
    return <GiftIcon key={i} />
  }
  if (item.type === 'startMolecule') {
    return <StartMoleculeIcon key={i} />
  }
  if (item.type === 'text') {
    const TextComponent = item.fixedSize ? FixedTextItem : TextItem

    return (
      <TextComponent key={i} dangerouslySetInnerHTML={{ __html: item.html }} />
    )
  }
  return null
}

const renderLegacyItem = (item, i, slide) => (
  <LegacyItem key={i} padding={slide.textLinePadding || 40}>
    <LegacyContent color={slide.textLineColor}>
      {item.text && <span>{item.text}</span>}
      {item.icon && (
        <LegacyImg
          imgSize={slide.textLineImageSize}
          src={`${CDN_BANNER}/${item.icon}`}
        />
      )}
    </LegacyContent>
  </LegacyItem>
)

const TextLineBanner = ({ slide, href }) => {
  if (!slide || !slide.textLineContent) return null

  const items = slide.textLineContent
  const repeatCount = slide.textLineRepeat || 4
  const repeatedItems = Array.from({ length: repeatCount }).reduce(
    result => result.concat(items),
    [],
  )
  const useNewSchema = isNewSchema(items)
  const textLineHref = slide.textLineHref === null
    ? null
    : slide.textLineHref || href

  return (
    <Root
      as={textLineHref ? 'a' : 'div'}
      href={textLineHref || undefined}
      target={textLineHref ? '_blank' : undefined}
      rel={textLineHref ? 'noopener noreferrer' : undefined}
      bg={slide.textLineBg}
      color={slide.textLineColor}
    >
      <Track
        style={{
          '--text-line-duration': `${slide.textLineDuration || 30}s`,
        }}
      >
        {useNewSchema
          ? repeatedItems.map((item, i) => (
            <Item key={i}>{renderNewItem(item, i)}</Item>
          ))
          : repeatedItems.map((item, i) => renderLegacyItem(item, i, slide))}
      </Track>
    </Root>
  )
}

TextLineBanner.propTypes = {
  slide: PropTypes.object,
  href: PropTypes.string,
}

TextLineBanner.defaultProps = {
  href: 'https://atlas.ru/cart?action=fill-cart&wgs=2&promocode=combo',
}

export default TextLineBanner
